import React from 'react';
import PropTypes from 'prop-types';
import { InputSelectOption } from '@bvt-shared/component/InputSelectOption';
import './DataPreview.scss';

export default function DataPreview(props) {
  return (
    <div className='feature-griana DataPreview'>
      <div className='feature-griana DataPreview--header'>Data preview</div>
      <div className='feature-griana DataPreview--wrapper'>
        {props.isLoading ? (
          <span style={{ height: '2rem' }} />
        ) : (
          <>
            <InputSelectOption
              allowClear={false}
              data={props.selectOption.data}
              onChange={props?.selectOption?.onChange}
              value={props.selectOption.value}
            />
            {props.showChange && (
              <div className='btn-fill' onClick={props?.changeArea?.onClick}>
                Change area
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

DataPreview.defaultProps = {
  changeArea: {
    onClick: undefined,
  },
  isLoading: true,
  showChange: true,
};

DataPreview.propTypes = {
  changeArea: PropTypes.shape({
    onClick: PropTypes.func,
  }),
  isLoading: PropTypes.bool,
  selectOption: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        value: PropTypes.string,
      })
    ),
    onChange: PropTypes.func,
    value: PropTypes.string,
  }),
  showChange: PropTypes.bool,
};
